/**
 * GA4 Purchase Tracking
 * Automaticky odešle purchase event když existuje window.ga4PurchaseData
 */

import * as GA4 from './ga4-ecommerce.js';

document.addEventListener('DOMContentLoaded', function() {
    // Check if purchase data exists (set by thank-you page template)
    if (window.ga4PurchaseData) {
        console.log('Purchase data found, sending to GA4:', window.ga4PurchaseData);

        // Send purchase event to GA4
        GA4.purchase(window.ga4PurchaseData);

        // Optional: Clear the data after sending to prevent duplicate sends
        window.ga4PurchaseData = null;
    }
});

export default {};
